import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import attackExperiment from 'assets/images/attack-experiment.svg'
import installGremlin from 'assets/images/install-gremlin.svg'
import Button from 'components/common/Button'
import Image from 'components/common/Image'
import Text from 'components/common/Text'
import Modal, {
  ModalHeader,
  ModalCloseButton,
  ModalTitle
} from 'components/Modal'
import theme from 'theme'

const buttonWidth = '220px'

export default function OnboardingAttackModal({ open, onCancel }) {
  return (
    <Modal
      css={{ width: theme.space[8] * 6 }}
      isOpen={open}
      onRequestClose={onCancel}
    >
      <ModalHeader css={{ textAlign: 'center' }}>
        <ModalCloseButton onClick={onCancel} />
        <ModalTitle css={{ marginBottom: theme.space[2] }}>
          Congratulations on running your first chaos experiment!
        </ModalTitle>
        <Text as="p">
          You&apos;re on your way to building confidence in the resiliency of
          your cloud infrastructure.
        </Text>
      </ModalHeader>
      <div
        css={{
          marginTop: theme.space[4],
          textAlign: 'center'
        }}
      >
        <Text
          as="h5"
          color="normal"
          css={{
            textTransform: 'uppercase'
          }}
        >
          What&apos;s next?
        </Text>
      </div>
      <section
        css={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: 'repeat(4, auto)',
          gridColumnGap: theme.space[7],
          gridRowGap: theme.space[4],
          paddingTop: theme.space[4],
          textAlign: 'center'
        }}
      >
        <Image
          alt="Gremlin experiment tooling"
          css={{ margin: 'auto' }}
          src={attackExperiment}
        />
        <div>
          <Text as="h5" css={{ marginBottom: theme.space[2] }}>
            Run another attack?
          </Text>
          <Text as="p">
            The Gremlin Platform provides a range of attacks which you can run
            simply and safely.
          </Text>
        </div>
        <Link to="/attacks/new">
          <Button css={{ width: buttonWidth }}>Run another attack</Button>
        </Link>
        <Image
          alt="Gremlin installing clients"
          css={{ margin: 'auto' }}
          src={installGremlin}
        />
        <div>
          <Text as="h5" css={{ marginBottom: theme.space[2] }}>
            Ready to install?
          </Text>
          <Text as="p">
            Gremlin can be installed on bare-metal, on prem, with VMs,
            containers, serverless and Kubernetes environments.
          </Text>
        </div>
        <div css={{ textAlign: 'center' }}>
          <Link to="/">
            <Button css={{ width: buttonWidth, marginLeft: theme.space[3] }}>
              Install Gremlin
            </Button>
          </Link>
        </div>
        <div
          css={{
            marginTop: theme.space[4],
            textAlign: 'center',
            gridRow: 4,
            gridColumn: '1 / 3'
          }}
        >
          <Link to="/">
            <Button
              secondary
              css={{ width: buttonWidth, marginLeft: theme.space[3] }}
            >
              Go to My Dashboard
            </Button>
          </Link>
        </div>
      </section>
    </Modal>
  )
}

OnboardingAttackModal.propTypes = {
  onCancel: PropTypes.func,
  open: PropTypes.bool
}
